import type { ApiMeta } from "@/apis/types";

/**
 * API metadata for WSDOT Toll Rates API
 */
export const wsdotTollRatesApiMeta: ApiMeta = {
  name: "wsdot-toll-rates",
  baseUrl: "https://www.wsdot.wa.gov/traffic/api/tollrates/tollratesrest.svc",
};
